(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ma-delivery-estimate')) return;
  const DAY = 86400000;
  const date = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const key = d => d.toISOString().slice(0, 10);
  const plus = (d, n) => new Date(d.getTime() + n * DAY);
  const holidayCache = new Map();
  function holidays(y) {
    if (holidayCache.has(y)) return holidayCache.get(y);
    const list = new Set();
    const observe = d => {
      while ([0, 6].includes(d.getUTCDay()) || list.has(key(d))) d = plus(d, 1);
      list.add(key(d));
    };
    observe(date(y, 1, 1));
    const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    const easter=date(y,Math.floor(n/31),n%31+1);
    list.add(key(plus(easter,-2))); list.add(key(plus(easter,1)));
    let may=date(y,5,1); while(may.getUTCDay()!==1) may=plus(may,1); list.add(key(may));
    for(const month of [5,8]) { let last=date(y,month+1,0); while(last.getUTCDay()!==1) last=plus(last,-1); list.add(key(last)); }
    const christmas=date(y,12,25),boxing=date(y,12,26);
    for(const x of [christmas,boxing]) if(![0,6].includes(x.getUTCDay())) list.add(key(x));
    for(const x of [christmas,boxing]) if([0,6].includes(x.getUTCDay())) observe(x);
    holidayCache.set(y,list); return list;
  }
  const working = d => ![0,6].includes(d.getUTCDay()) && !holidays(d.getUTCFullYear()).has(key(d));
  function business(d,n) { let out=new Date(d); while(n>0) {out=plus(out,1); if(working(out)) n--;} return out; }
  function roll(d) { while(!working(d)) d=plus(d,1); return d; }
  function clock(now=new Date()) {
    const p=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(now).map(x=>[x.type,x.value]));
    const today=date(+p.year,+p.month,+p.day);
    const seconds=+p.hour*3600 + +p.minute*60 + +p.second;
    const base=working(today)&&seconds<14*3600 ? today : business(today,1);
    return {today,base,count:Math.max(0,(base-today)/1000+14*3600-seconds)};
  }
  const fmt=d=>new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'short',day:'numeric',month:'short'}).format(d);
  const range=(a,b)=>key(a)===key(b)?fmt(a):`${fmt(a)} – ${fmt(b)}`;
  function parseLead(text) {
    const match=text.match(/ships?\s+(?:within|in)\s+(\d{1,3})(?:\s*[-–—]\s*(\d{1,3}))?\s*(working\s+|business\s+)?days?/i);
    if(!match) return null;
    const min=+match[1],max=+(match[2]||match[1]);
    return min<=max && max<=365 ? {min,max,business:!!match[3]} : null;
  }
  function explicitDate(text) {
    if(!/^\d{4}-\d{2}-\d{2}/.test(text||'')) return null;
    const value=new Date(text.slice(0,10)+'T00:00:00Z');
    return Number.isFinite(+value) && key(value)===text.slice(0,10) ? value : null;
  }
  function cached(id) {
    try { const data=JSON.parse(sessionStorage.getItem('ma-preorder-lead:'+id)); return data && Date.now()-data.saved<1800000 ? data.lead : null; } catch {return null;}
  }
  function remember(id,lead) {try {sessionStorage.setItem('ma-preorder-lead:'+id,JSON.stringify({saved:Date.now(),lead}));} catch {}}
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {clearInterval(this.timer); this.update(); this.timer=setInterval(()=>this.update(),1000);}
    disconnectedCallback() {clearInterval(this.timer);}
    text(selector,text) {const node=this.querySelector(selector); if(node && node.textContent!==text) node.textContent=text;}
    update() {
      const labels=this.querySelector('[data-labels]')?.dataset;
      if(!labels) return;
      const context=this.dataset.context;
      let items=Array.from(this.querySelectorAll('[data-delivery-item]')).map(e=>({...e.dataset}));
      const now=clock();
      let appLead=null,appPreorder=false;
      if(context==='product') {
        const scope=this.closest('.shopify-section')||document;
        const input=scope.querySelector('product-form-component form input[name="id"]');
        const selected=input?.value||this.dataset.selected;
        items=items.filter(x=>x.variant===selected);
        const app=scope.querySelector('.essential-preorder-container-active [data-essential-preorder-element="message"]');
        appPreorder=!!app && app.getClientRects().length>0;
        if(appPreorder) appLead=parseLead(app.textContent||'');
        if(appLead) remember(selected,appLead);
      }
      if(!items.length) {this.hidden=true;return;}
      let pre=false,unknown=false,unavailable=false;
      let first=now.base,last=business(now.base,1);
      for(const item of items) {
        const isPre=item.preorder==='true'||appPreorder;
        if(context==='product' && item.available==='false') unavailable=true;
        if(!isPre) continue;
        pre=true;
        const explicit=explicitDate(item.shipDate);
        let min,max;
        if(explicit && explicit>=now.today) {min=roll(explicit);max=min;}
        else if(item.shipDate) {unknown=true;continue;}
        else {
          const lead=appLead||parseLead(item.message||'')||cached(item.variant);
          if(!lead) {unknown=true;continue;}
          min=lead.business?business(now.today,lead.min):roll(plus(now.today,lead.min));
          max=lead.business?business(now.today,lead.max):roll(plus(now.today,lead.max));
        }
        if(min>first) first=min;
        if(max>last) last=max;
      }
      if(context==='line' && !pre) {this.hidden=true;return;}
      this.hidden=false;
      const international=this.dataset.service==='international';
      const service=international?labels.international:this.dataset.service==='express'?labels.express:labels.standard;
      const transit=international?[6,7]:this.dataset.service==='express'?[1,1]:[2,2];
      const arrival=range(business(first,transit[0]),business(last,transit[1]));
      const dispatch=range(first,last);
      this.text('[data-delivery-service]',service);
      const steps=this.querySelector('[data-delivery-steps]');
      if(steps) steps.hidden=unknown||unavailable;
      const message=this.querySelector('[data-delivery-message]');
      const text=unavailable?labels.unavailable:unknown?labels.unknown:pre?`${labels.preorder} · ${labels.dispatch} ${dispatch}`:context==='product'?labels.cutoff:`${labels.receiveBy} ${arrival}${international?' · '+service:''}`;
      if(message && message.dataset.value!==text) {message.textContent=text; message.dataset.value=text;}
      if(context==='product'&&!pre&&!unavailable) {
        let timer=message.querySelector('strong');
        if(!timer) {timer=document.createElement('strong');message.append(' ',timer,' '+labels.receive);}
        const total=Math.floor(now.count),days=Math.floor(total/86400),hours=Math.floor(total%86400/3600),mins=Math.floor(total%3600/60),secs=total%60;
        const value=`${days?days+'d ':''}${hours}h ${String(mins).padStart(2,'0')}m ${String(secs).padStart(2,'0')}s`;
        if(timer.textContent!==value) timer.textContent=value;
      }
      this.text('[data-ordered]',fmt(now.today));
      this.text('[data-shipped]',dispatch);
      this.text('[data-delivered]',arrival);
      this.text('[data-delivery-note]',context==='line'?'':unknown?'':context==='cart'?(pre?`${labels.receiveBy} ${arrival}${international?' · '+service:''}`:''):labels.note);
    }
  }
  customElements.define('ma-delivery-estimate',DeliveryEstimate);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ma-product-guidance"] && !Shopify.designMode) return;
  try {
    // The app can intercept its rating link before the reviews iframe is ready.
  // Scroll to the existing review container, which also works while it loads.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('.product-details a[href="#looxReviewsFrame"]')
      : null;
    const reviews = link && document.getElementById('looxReviews');
    if (!reviews) return;
    event.preventDefault();
    event.stopPropagation();
    reviews.scrollIntoView({
      block: 'start',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
    if (event.detail === 0) {
      reviews.setAttribute('tabindex', '-1');
      reviews.focus({ preventScroll: true });
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
